exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4843b705]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #efefef;\n}\n\n/* Mixins */\n.svg-icon[data-v-4843b705] {\n  margin-right: 16px;\n}\n.simple-mode .svg-icon[data-v-4843b705] {\n  margin-left: 20px;\n}", ""]);

